// assets
import { DollarOutlined } from '@ant-design/icons';

// icons
const icons = { DollarOutlined };

// ==============================|| MENU ITEMS - PRESTAMOS ||============================== //

const prestamos = {
  id: 'group-prestamos',
  title: 'Préstamos',
  type: 'group',
  children: [
    { id: 'prestamos', title: 'Préstamos', type: 'item', url: '/prestamos', icon: icons.DollarOutlined, permission: 'prestamos.read' }
  ]
};

export default prestamos;
